import { loadPlacesLibrary } from "../../../../../helpers/googleMaps/GoogleMapsLoader";

export const GOOGLE_PLACES_OPTION_SOURCE = "google_places";
export const GOOGLE_PLACES_MIN_QUERY_LENGTH = 3;

export const normalizeSearchText = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

export const isGooglePlacesOption = (option) =>
  option?.source === GOOGLE_PLACES_OPTION_SOURCE;

const getAddressComponent = (addressComponents, type) =>
  addressComponents.find((component) => component.types?.includes(type))
    ?.long_name;

const formatGooglePlaceAddressName = (place, fallback) => {
  const addressComponents = place.address_components || [];
  const route = getAddressComponent(addressComponents, "route");
  const streetNumber = getAddressComponent(addressComponents, "street_number");

  if (route && streetNumber) return `${route} ${streetNumber}`;
  if (route) return route;

  const formattedAddress = place.formatted_address || fallback || "";
  return formattedAddress.split(",")[0].trim() || formattedAddress;
};

export const getGooglePredictions = async (input) => {
  const placesLibrary = await loadPlacesLibrary();

  return new Promise((resolve) => {
    const service = new placesLibrary.AutocompleteService();
    service.getPlacePredictions(
      {
        input,
        componentRestrictions: { country: "pe" },
      },
      (predictions, status) => {
        if (status !== placesLibrary.PlacesServiceStatus.OK || !predictions) {
          resolve([]);
          return;
        }

        resolve(
          predictions.map((prediction) => ({
            source: GOOGLE_PLACES_OPTION_SOURCE,
            placeId: prediction.place_id,
            name: prediction.description,
            description: prediction.description,
          })),
        );
      },
    );
  });
};

export const getGooglePlaceAddress = async (option) => {
  const placesLibrary = await loadPlacesLibrary();

  return new Promise((resolve, reject) => {
    const service = new placesLibrary.PlacesService(
      document.createElement("div"),
    );
    service.getDetails(
      {
        placeId: option.placeId,
        fields: ["address_components", "formatted_address", "geometry", "name"],
      },
      (place, status) => {
        if (status !== placesLibrary.PlacesServiceStatus.OK || !place) {
          reject(new Error("No se pudo obtener el detalle de la ubicacion"));
          return;
        }

        const location = place.geometry?.location;
        if (!location) {
          reject(new Error("No se encontraron coordenadas de la ubicacion"));
          return;
        }

        resolve({
          name: formatGooglePlaceAddressName(place, option.description),
          latitude: location.lat(),
          longitude: location.lng(),
          url: "",
          url_address: "",
          googlePlaceId: option.placeId,
        });
      },
    );
  });
};
